import React from "react";
import { ReactSVG } from "react-svg";
import { CalendarIconGray, ClockIconGray } from "../../constant/imagePath";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import classes from "./performanceEvaluationMobileCard.module.css";

function PerformanceEvaluationMobileCard({ data }) {
  return (
    <div className={classes.card}>
      <div className={`${[classes.header].join(" ")}`}>
        {/* Image */}
        <img
          src={data?.userData?.photo}
          className={`${[classes.cardImg].join(" ")}`}
        />
        {/* Name and Date and Time */}
        <div className={`${[classes.name].join(" ")}`}>
          <h5 style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}>
            {data?.userData?.displayName?.split(" ")[0]}
          </h5>
          <h5 style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}>
            {data?.userData?.displayName?.split(" ")[1]}
          </h5>
        </div>
      </div>

      <ul>
        <li style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
          <ReactSVG src={CalendarIconGray} />
          <span style={{ ...Fonts.p2 }}>{data?.date}</span>
        </li>
        <li style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
          <ReactSVG src={ClockIconGray} />

          <span style={{ ...Fonts.p2 }}>{data?.time}</span>
        </li>
      </ul>
      <p
        className={classes.description}
        style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
      >
        John has a knack. He can teach through his writings. He inspires
        confidence in his students, and by reading. Watch the Ball, you'll be
        inspired too.
      </p>
    </div>
  );
}

export default PerformanceEvaluationMobileCard;
